import moment from "moment";
import { FiCalendar } from "react-icons/fi";
import ModalDailog from "../../../Components/Modal";
import { formatUrl, isValidURL } from "../../../utils/helper";
import { AdaCompliant, DisabilityAccessible, GendersServed, LGBTQFriendly, LocationType, PublicTransportation, Referral, RoomType, ShelterInformationForthcoming, UrbanRuralClassification } from "./CollaborativeInfo";

const ViewAgencyModelInfo = ({
    isModalOpenSheltercc,
    closeModalSheltercc,
    agencyData,
    groupId
}: {
    isModalOpenSheltercc: boolean;
    closeModalSheltercc: () => void;
    agencyData: any;
    groupId: string | null;
}) => {
    const { regionalSupporter, canAnswerRequest, canSendRequest } =
        agencyData.groupInfo?.find((groupInfo: any) => groupInfo?.groupId === groupId) || {};
    const isReferral = !canAnswerRequest && canSendRequest;
    const city = ((agencyData.details?.city || "").split(",")[0] || "").trim();
    const state = (
        agencyData.details?.state ||
        (agencyData.details?.city || "").split(",")[1] ||
        ""
    ).trim();

    return (
        <ModalDailog isOpen={isModalOpenSheltercc} onClose={closeModalSheltercc} title={agencyData?.name} isFooterAvailable={false}>
            <div className="card-header flex items-center justify-between mb-5 text-gray-600 font-medium">
                <div className="flex flex-wrap space-x-4">
                    {isReferral && (
                        <span className="py-1 px-3 rounded-full text-secondary 2xl:text-sm bg-blue-100">Referral Only</span>
                    )}
                    {canAnswerRequest && (
                        <span className="py-1 px-3 rounded-full text-white 2xl:text-sm bg-primary">Shelter</span>
                    )}
                    {regionalSupporter && (
                        <span className="py-1 px-3 rounded-full text-white 2xl:text-sm bg-secondary">Regional Supporter</span>
                    )}
                </div>
                {agencyData?.profile?.memberSince != "__private__" && (
                    <div className="flex items-center">
                        <FiCalendar className="me-3" size={20} />
                        <span className="2xl:text-base">Member since{" "}
                            {moment(agencyData?.profile?.memberSince || agencyData?.createdAt).format(
                                "MMMM YYYY",
                            )}
                        </span>
                    </div>
                )}
            </div>
            <div className="flex text-sm 2xl:text-base">
                <div className="w-1/2">
                    <p className="text-dark mb-3">Location info:</p>
                    <p className="text-gray-600">
                        {city}
                        {state ? ", " + state : ""}
                    </p>
                    {agencyData?.profile?.county != "__private__" && (
                        <p>{agencyData?.profile?.county}</p>
                    )}
                </div>
                {canAnswerRequest && (
                    <div className="w-1/2">
                        <p className="text-dark mb-3">About the shelter:</p>
                        <Referral agency={agencyData} />
                        <GendersServed agency={agencyData} />
                        <RoomType agency={agencyData} />
                        <AdaCompliant agency={agencyData} />
                        <DisabilityAccessible agency={agencyData} />
                        <PublicTransportation agency={agencyData} />
                        <UrbanRuralClassification agency={agencyData} />
                        <LocationType agency={agencyData} />
                        <LGBTQFriendly agency={agencyData} isModal={true} />
                        <ShelterInformationForthcoming agency={agencyData} />
                    </div>
                )}
                {agencyData?.profile?.website && isValidURL(agencyData.profile.website) && (
                    <div className="md:w-1/3 mb-3 md:mb-0">
                        <p className="text-dark font-medium mb-2 md:mb-3">Website</p>
                        {agencyData?.profile.website != "__private__" && (
                            <a href={formatUrl(agencyData?.profile.website)} target="_blank" className="text-primary font-semibold break-words">
                                {agencyData?.profile.website}
                            </a>
                        )}
                    </div>
                )}
            </div>

        </ModalDailog>
    );
};

export default ViewAgencyModelInfo;